<template>
	<div class="col-lg-8">
		<div class="tile">
			<ul>
				<li v-for="item in data.filter(x => !x.is_hidden)" :key="item.id">
					<RouterLink :to="`${name}/${item.id}`" :data-id="item.id">
						{{ item.name }}
					</RouterLink>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import { getDataJson } from '@/api/getData'
import { getConfig } from '@/auth'

export default {
	data() {
		return {
			name: '',
			data: []
		}
	},
	async created() {
		this.name = this.$route.path;
		const url = getConfig().apiURL + '/public-hearing/ph-projects';
		this.data = await getDataJson(url);
	},
}
</script>